/**
 * Support Email Configuration Utility
 * 
 * Centralizes support email configuration to avoid hardcoded values.
 * Uses environment variable with fallback for development.
 * 
 * Environment variable: REACT_APP_SUPPORT_EMAIL
 * Fallback (development only): srose@norwalkls.com
 */

/**
 * Get the support email address
 * @returns Support email address
 */
export const getSupportEmail = (): string => {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
  
  if (supportEmail) {
    return supportEmail;
  }
  
  // Fallback for development only - should be set in production
  if (process.env.NODE_ENV === 'development') {
    return 'srose@norwalkls.com';
  }
  
  // In production, throw error if not set
  throw new Error(
    'REACT_APP_SUPPORT_EMAIL is not set. ' +
    'This is required for production. ' +
    'Please set REACT_APP_SUPPORT_EMAIL in your .env.production file or build configuration.'
  );
};

/**
 * Get the super admin email address (for access control)
 * @returns Super admin email address
 */
export const getSuperAdminEmail = (): string => {
  const superAdminEmail = process.env.REACT_APP_SUPER_ADMIN_EMAIL;
  
  if (superAdminEmail) {
    return superAdminEmail;
  }
  
  // Fallback for development only - should be set in production
  if (process.env.NODE_ENV === 'development') {
    return 'srose@norwalkls.com';
  }
  
  // In production, throw error if not set
  throw new Error(
    'REACT_APP_SUPER_ADMIN_EMAIL is not set. ' +
    'This is required for production. ' +
    'Please set REACT_APP_SUPER_ADMIN_EMAIL in your .env.production file or build configuration.'
  );
};
